import { AutoComplete, Input } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

/**
 * SelectUser
 *
 * Searchable user selector with AutoComplete.
 *
 * Props:
 *   users    - array of user objects with { id, name }
 *   value    - currently selected user object (or null)
 *   onChange - called with the full user object when a user is selected (or null when cleared)
 */
export const SelectUser = ({ users = [], value = null, onChange }) => {
  const [search, setSearch] = useState(value?.name || "");
  const [filtered, setFiltered] = useState(users);

  const handleSearch = (text) => {
    const safeText = text || "";
    setSearch(safeText);
    const lower = safeText.toLowerCase();
    setFiltered(users.filter((u) => u.name.toLowerCase().includes(lower)));
    if (!safeText) onChange(null);
  };

  const handleSelect = (val) => {
    const user = users.find((u) => u.id === parseInt(val));
    setSearch(user?.name || "");
    setFiltered(users);
    onChange(user || null);
  };

  // Sync display when value changes externally
  useEffect(() => {
    setSearch(value?.name || "");
    setFiltered(users);
  }, [value?.id, users]);

  return (
    <AutoComplete
      style={{ width: "100%" }}
      value={search}
      onChange={handleSearch}
      onSelect={handleSelect}
      options={filtered.map((u) => ({
        label: <p>{u.name}</p>,
        value: String(u.id),
      }))}
      notFoundContent={<p className="center">{$t("Niet gevonden")}</p>}
      allowClear={true}
    >
      <Input placeholder={$t("Zoek gebruiker")} />
    </AutoComplete>
  );
};
